export default "__VITE_ASSET__c5e0107e__"